import { useField, useFormikContext } from 'formik';
import PropTypes from 'prop-types';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

import { DatePicker, DateTimePicker, LocalizationProvider, TimePicker } from '@mui/x-date-pickers';
import { TextField } from '@mui/material';
import { at } from 'lodash';
import dayjs from 'dayjs';

function EditHourPicker(props:any) {

  const today = dayjs();

  const [field, meta] = useField(props);

  const formikProps:any = useFormikContext()

  const { label, dateAdapter, defaultHour }:any = props;


  function _renderHelperText() {
    const [touched, error] = at(meta, 'touched', 'error');
    
    if (touched && error) {
        return error;
    }
  }
 
    
  return (
    <LocalizationProvider dateAdapter={dateAdapter}>
        <TimePicker 
          {...props}
          defaultValue={ defaultHour  }
          label={label}
          name={field.name}
          helperText={meta.error}
          error={meta.touched && Boolean(meta.error)}
          views={['hours', 'minutes']}
          onChange={(value) => formikProps.setFieldValue(field.name, value)}
          slotProps={{
            textField: {
              error: meta.touched && meta.error && true,
              helperText: true ? _renderHelperText():""
            },
          }}
        />
    </LocalizationProvider>
  );
}


EditHourPicker.defaultProps = {
    label: '',
    name: '',
    defaultHour: AdapterDayjs,
    dateAdapter: AdapterDayjs,
    views: ['hours', 'minutes']
};

EditHourPicker.propTypes = {
    label: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    dateAdapter: PropTypes.any.isRequired,
    views: PropTypes.array,
};

export default EditHourPicker;